import * as vp from 'vopay';

import { FunctionComponent, useContext, useMemo } from 'react';
import LeadCreationContext from './LeadCreationContext';

import { DialogueHandler, LeadCreationDialogueHandlers } from '../types';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type LeadCreationDialogueProps = {
  handleDialogue: DialogueHandler<LeadCreationDialogueHandlers>;
};

type FC = FunctionComponent<LeadCreationDialogueProps>;

const LeadCreationDialogue: FC = ({ handleDialogue }: LeadCreationDialogueProps) => {
  const { showLeadCreateSuccessAlert, showLeadCreateErrorAlert, leadCreateError } = useContext(LeadCreationContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Leads.Create.Dialog' });
  return useMemo(
    () => (
      <div>
        {/* Delete User Error */}

        <ConfirmationDialogue
          isVisible={showLeadCreateErrorAlert}
          title={t('DeleteUserError.title')}
          status="error"
          subTitle={`${leadCreateError}`}
          confirm={{
            label: t('DeleteUserError.confirmButton'),
            action: () => handleDialogue({ type: 'create', state: 'fail' }),
          }}
        />

        {/* Delete User Success */}

        <ConfirmationDialogue
          isVisible={showLeadCreateSuccessAlert}
          status="success"
          title={t('DeleteUserSuccess.title')}
          confirm={{
            label: t('DeleteUserSuccess.confirmButton'),
            action: () => handleDialogue({ type: 'create', state: 'success' }),
          }}
        />
      </div>
    ),
    [showLeadCreateSuccessAlert, showLeadCreateErrorAlert],
  );
};

export default LeadCreationDialogue;
